import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5486_2299)">
      <rect
        width="24"
        height="24"
        rx="4"
        transform="matrix(-1 0 0 1 24 0)"
        fill="#FDFEFF"
        fill-opacity="0.927"
      />
      <g filter="url(#filter0_d_5486_2299)">
        <path
          d="M14.2982 14.1979L17.2094 17.0297L15.8437 18.3583L12.932 15.5271C12.6821 15.2839 12.3537 15.1517 11.9993 15.1517C11.6449 15.1517 11.3154 15.2839 11.066 15.5271L8.15431 18.3583L6.78812 17.0297L9.69984 14.1979H14.2982Z"
          fill="#12181C"
        />
        <path
          d="M18.7597 14.4162L14.7837 13.3815L14.7816 13.3794L12.4826 9.5082L13.5469 5.64172L15.4145 6.12708L14.3502 9.99409C14.3046 10.1567 14.2928 10.3269 14.3154 10.4943C14.338 10.6616 14.3946 10.8226 14.4818 10.9674C14.5693 11.1146 14.6851 11.2432 14.8226 11.3457C14.9601 11.4482 15.1165 11.5227 15.2829 11.5649L19.259 12.6001L18.7597 14.4162Z"
          fill="#12181C"
        />
        <path
          d="M9.2165 13.3815L5.24047 14.4162L4.74121 12.6001L8.71724 11.5649C8.88369 11.5227 9.04014 11.4481 9.17762 11.3455C9.3151 11.2429 9.4309 11.1142 9.51838 10.9669C9.60554 10.8221 9.66216 10.6611 9.68478 10.4937C9.70741 10.3264 9.69556 10.1562 9.64996 9.99356L8.58619 6.12708L10.4538 5.64172L11.5181 9.5082L9.21915 13.3794L9.2165 13.3815Z"
          fill="#12181C"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5486_2299"
        x="-18.9521"
        y="-13.3129"
        width="61.9045"
        height="60.1032"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.73867" />
        <feGaussianBlur stdDeviation="11.8467" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5486_2299"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5486_2299"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_5486_2299">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
